var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [_vm._v("Whatsapp Feature")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Brodcast Message Per Price"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.brodcastPerMessage,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "brodcastPerMessage", $$v)
                },
                expression: "featureForm.brodcastPerMessage",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [_vm._v("Other Features")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.bulkMessageSending,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "bulkMessageSending", $$v)
                  },
                  expression: "featureForm.bulkMessageSending",
                },
              },
              [_vm._v("Bulk Message Sending")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.messageUnregisteredNumbers,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "messageUnregisteredNumbers", $$v)
                  },
                  expression: "featureForm.messageUnregisteredNumbers",
                },
              },
              [_vm._v("Message Unregisted Numbers")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.personalizedBroadcastMessage,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.featureForm,
                      "personalizedBroadcastMessage",
                      $$v
                    )
                  },
                  expression: "featureForm.personalizedBroadcastMessage",
                },
              },
              [_vm._v("Personalized Broadcast Message\n                ")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.chatbotEntergration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "chatbotEntergration", $$v)
                  },
                  expression: "featureForm.chatbotEntergration",
                },
              },
              [_vm._v("Chatbot Entegration")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.controlWhatsapp,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "controlWhatsapp", $$v)
                  },
                  expression: "featureForm.controlWhatsapp",
                },
              },
              [_vm._v("Manage Whatsapp")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.notAdditionalPrice,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "notAdditionalPrice", $$v)
                  },
                  expression: "featureForm.notAdditionalPrice",
                },
              },
              [_vm._v(" Ek Maliyet Gerekmez")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }